import { createSlice } from "@reduxjs/toolkit";

interface ContractInitialStateModel {
  filter:any;
}
const ContractInitialState: ContractInitialStateModel = {
  filter:{
    PageIndex:1,
    PageSize:20,
  

  }
};

const contractSlice = createSlice({
  name: "ContractSlice ",
  initialState: ContractInitialState,
  reducers: {
    handleSetContractFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleResetContractFitler: (state, ) => {
      state.filter = {
        PageIndex:1,
        PageSize:20,
        
      };
    },
  },
});

export const {
  handleSetContractFilter,
  handleResetContractFitler,
} = contractSlice.actions;
export default contractSlice;
